module.exports = __webpack_public_path__ + "img/lang-fr.4150b280.png";